module.exports = __webpack_public_path__ + "img/143.9f5e3a00.jpg";